import React from 'react';
import './App.css';
import Terminal from './components/Terminal';

function App() {
  return (
    <div className="App">
      <Terminal />
    </div>
  );
}

export default App;